import React from 'react';
import PropTypes from 'prop-types';

var Loader = function Loader(_ref) {
  var inline = _ref.inline;

  var wrapperClasses = ['Loader'];
  inline && wrapperClasses.push('Loader--inline');

  return React.createElement(
    'div',
    { className: wrapperClasses.join(' ') },
    React.createElement(
      'div',
      { className: 'loading-content' },
      React.createElement('div', { className: 'loader-icon' }),
      React.createElement(
        'div',
        { className: 'loading-spinner' },
        React.createElement('div', { className: 'bounce1' }),
        React.createElement('div', { className: 'bounce2' }),
        React.createElement('div', { className: 'bounce3' })
      )
    ),
    React.createElement('div', { className: 'loader-overlay' })
  );
};

Loader.propTypes = {
  /** Allows for optional css class for inline cases when passed as props from sites */
  inline: PropTypes.bool
};

Loader.defaultProps = {
  inline: false
};

export default Loader;